// Vyhledávání lokalit v České republice.
//
// Seznam obcí a měst je uložený na serveru v tabulce locations, našeptávání
// tak běží proti vlastní databázi a nespoléhá na žádné externí API.

const API_URL = process.env.REACT_APP_API_URL || "https://api.techwatch.app";

// Backend vrací { name, city, postcode, district, region, lat, lng, displayName },
// formulář ale pracuje s { label, city, postcode, latitude, longitude }.
// U městské části je name název části ("Žižkov") a city nadřazená obce
// ("Praha"), u obce jsou obě hodnoty stejné.
const toLocation = (item, coordinates = null) => ({
    label: item.displayName,
    name: item.name,
    city: item.city,
    district: item.district,
    region: item.region,
    postcode: item.postcode || null,
    country: "Česká republika",
    countryCode: "cz",
    // U aktuální polohy ponecháme přesné souřadnice uživatele, aby šlo
    // filtrovat podle vzdálenosti opravdu od něj
    latitude: coordinates?.latitude ?? item.lat,
    longitude: coordinates?.longitude ?? item.lng,
});

const fetchJson = async (path, params, signal) => {
    const query = new URLSearchParams(params);

    const response = await fetch(`${API_URL}${path}?${query.toString()}`, {
        headers: { Accept: "application/json" },
        signal,
    });

    if (!response.ok) {
        throw new Error("Lokality se nepodařilo načíst.");
    }

    return response.json();
};

// Našeptávání obcí a měst podle zadaného textu
export const searchLocations = async (query, { signal } = {}) => {
    const items = await fetchJson(
        "/api/locations/search",
        { q: query },
        signal
    );

    return items.map((item) => toLocation(item));
};

// Nejbližší obec ke zadaným souřadnicím
export const nearestLocation = async (latitude, longitude, { signal } = {}) => {
    const item = await fetchJson(
        "/api/locations/nearest",
        { lat: String(latitude), lng: String(longitude) },
        signal
    );

    return toLocation(item, { latitude, longitude });
};

// Získání aktuální polohy prohlížeče jako slib
export const getCurrentPosition = () =>
    new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("Geolokace není v tomto prohlížeči podporována."));
            return;
        }

        navigator.geolocation.getCurrentPosition(
            ({ coords }) =>
                resolve({
                    latitude: coords.latitude,
                    longitude: coords.longitude,
                }),
            (error) => {
                const messages = {
                    1: "Přístup k poloze byl odepřen.",
                    2: "Vaši polohu se nepodařilo určit.",
                    3: "Určení polohy vypršelo.",
                };

                reject(new Error(messages[error.code] || "Polohu se nepodařilo určit."));
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
        );
    });
